<template>
  <div class="post">
    <loading :active.sync="isLoading" 
        :can-cancel="false" 
		:is-full-page="true"></loading>
    
    <div class="about-body">
    <div class="container">
        <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-justify">
            <div class="text-center" style="width: 100%; height: 100px; margin: 100px auto;">
               <div v-if="showSuccessBox" style="padding: 30px 10px;background: #a8ffac;">
                    <h3>Congratulation!</h3>
                    <p>Requested amount has been loaded in your <strong>Amej Wallet</strong> successfully.</p>
                    <a href="/app" class="btn btn-success">Go To Dashboaard</a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a href="/app/loadpayu" class="btn btn-primary">Load Money Again</a>
               </div>
               <div v-else>
                    <h3>Please Wait For Finish</h3>
                    <p>We are submit your data to the server</p>
               </div>
            </div>
        </div>
        </div>
    </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapActions } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    name: 'payusuccess',
    components: {
		Loading
	},
    computed: {
        ...mapState([
        "message",
        "successmessage",
        "errormessage",
        "profile"
        ]),
    },
    data(){
        return{
            isLoading: true,
            showSuccessBox: false,
            payuFormData : JSON.parse(localStorage.getItem('payuFormData')),
        }
    },
    created(){
      this.listProfile();
    },
    mounted(){

        if(this.payuFormData == null){
			this.$router.replace({
				name: 'loadpayu'
			})
		}

        let status = this.$route.query.status
        if(status == 'success'){
            let formData = new FormData();
            formData.append("txnid", this.payuFormData.txnid);
            formData.append("amount", this.payuFormData.amount);
            formData.append("status", 'success');
            formData.append("currency", 'INR');

            this.$store.dispatch("loadPayuMoney", formData)
            .then(() => {
                if (this.successmessage == "success") {
                    localStorage.removeItem('payuFormData')
                    this.showSuccessBox = true
                    this.isLoading = false
                    setTimeout(() => {
                        this.$router.replace({
                            name: 'app'
                        })
                    }, 5000);
                } else if (this.errormessage == "errormessage") {
                    this.$router.replace({
                        name: 'loadpayu'
                    })
                }
            });
        }
    },
    methods: {
        ...mapActions(["listProfile"]),
    },
}
</script>